import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as yup from "yup";
import { Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { customerRegister, fetchHeardAboutUs } from "../../Services/CustomerService";
import { addAddress } from "../../Services/AddressesService";

const validationSchema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^(3)|(2)([0-9]{9})$/g, "Please enter a valid number!")
    .required("This field is required..."),
  f_name: yup.string().required("This field is required..."),
  l_name: yup.string().required("This field is required..."),
  email: yup.string().email("Please enter a valid email"),
  password: yup.string().required("This field is required..."),
});

export const CustomerAdd = () => {
  const [submitting, setSubmitting] = React.useState(false);
  const [heardAboutUs, setHeardAboutUs] = React.useState({
    options: [], loading: true, error: false,
  });
  const heardAboutUsMounted = React.useRef(false);

  const loadHeardAboutUs = React.useCallback(() => {
    setHeardAboutUs((current) => ({ ...current, loading: true, error: false }));
    return fetchHeardAboutUs()
      .then((res) => {
        if (!heardAboutUsMounted.current) return;
        if (res?.success === false || !Array.isArray(res?.data) || !res.data.length) {
          throw new Error("No heard-about-us options available.");
        }
        setHeardAboutUs({ options: res.data, loading: false, error: false });
      })
      .catch(() => {
        if (!heardAboutUsMounted.current) return;
        setHeardAboutUs({ options: [], loading: false, error: true });
      });
  }, []);

  React.useEffect(() => {
    heardAboutUsMounted.current = true;
    loadHeardAboutUs();
    return () => { heardAboutUsMounted.current = false; };
  }, [loadHeardAboutUs]);
  const userType = useSelector((x) => x.UserType);
  const config = useSelector((x) => x.Config);
  const store = useSelector((x) => x.Store);
  const loggedIn = useSelector((x) => x.LoggedIn);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      f_name: "",
      l_name: "",
      phone: "",
      email: "",
      password: "",
      heard_about_us: "",
      referred_by: "",
      fcm_token: "dfskjfkjshfksdhfdskhfsdfkh",
    },
    validationSchema: validationSchema.shape({
      heard_about_us: yup.string()
        .oneOf(heardAboutUs.options.map((option) => option.value), "Please select a valid option")
        .required("This field is required..."),
    }),
    onSubmit: (v) => {
      const payload = { ...v, phone: `+92${v.phone}` };
      setSubmitting(true);
      customerRegister(payload).then(
        (res) => {
          const p2 = {
            address_type: "other",
            contact_person_number: payload.phone,
            address: store?.laundry_store?.store_address?.[0]?.address,
            latitude: store?.laundry_store?.store_address?.[0]?.latitude,
            longitude: store?.laundry_store?.store_address?.[0]?.longitude,
            zoneId: store?.laundry_store?.store_address?.[0]?.zone_id,
            contact_person_name: `${payload.f_name} ${payload.l_name}`,
            laundryZoneId: store?.laundry_store?.store_address?.[0]?.zone_id,
            area_id: store?.laundry_store?.store_address?.[0]?.laundry_area_id,
            area_phase_id:
              store?.laundry_store?.store_address?.[0]?.laundry_area_phase_id,
            address1: store?.laundry_store?.store_address?.[0]?.address1,
            address2: store?.laundry_store?.store_address?.[0]?.address2,
            user_id: res.data.id,
          };
          console.log(p2);
          addAddress(p2).then(
            (res) => {
              navigate(`/store/customers/view/${p2.user_id}`);
              setSubmitting(false);
            },
            (er) => {
              navigate(`/store/customers/view/${res.data.id}`);
              setSubmitting(false);
              if (er && er.errors && er.errors.length > 0) {
                er.errors.forEach((x) => toast.error(x.message));
              } else
                toast.error(
                  `Something went wrong while ${
                    payload?.id ? "updating" : "adding"
                  } new address...`
                );
            }
          );
        },
        ({ errors }) => {
          setSubmitting(false);
          if (typeof errors == "string") {
            toast.error(errors, { autoClose: 5000 });
          } else {
            if (errors?.length > 0) {
              errors.forEach((z) => {
                toast.error(z.message, { autoClose: 5000 });
              });
            }
          }
        }
      );
    },
  });
  return (
    <div className="container py-4" style={{ minHeight: "80vh" }}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body pb-4">
              <h3 className="mb-0 ">Create Customers</h3>
              <hr style={{ borderColor: "#282828" }} />
              <form
                className="row align-items-end gy-4"
                onSubmit={formik.handleSubmit}
              >
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="f_name">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="f_name"
                      style={{ padding: "0.375rem 0.75rem" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.f_name}
                    />
                    {Boolean(formik.errors.f_name) && formik.touched.f_name ? (
                      <Form.Text className="text-white">
                        {formik.errors.f_name}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="l_name">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="l_name"
                      style={{ padding: "0.375rem 0.75rem" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.l_name}
                    />
                    {Boolean(formik.errors.l_name) && formik.touched.l_name ? (
                      <Form.Text className="text-white">
                        {formik.errors.l_name}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      style={{ padding: "0.375rem 0.75rem" }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {Boolean(formik.errors.email) && formik.touched.email ? (
                      <Form.Text className="text-white">
                        {formik.errors.email}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="phone">
                    <Form.Label>Phone</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>+92</InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="phone"
                        placeholder="3xxxxxxxxx"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone}
                      />
                    </InputGroup>
                    {Boolean(formik.errors.phone) && formik.touched.phone ? (
                      <Form.Text className="text-danger">
                        {formik.errors.phone}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${
                        Boolean(formik.errors.password) &&
                        formik.touched.password
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {Boolean(formik.errors.password) &&
                    formik.touched.password ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.password}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="heard_about_us">
                    <Form.Label>Where did you hear about us?</Form.Label>
                    <Form.Select
                      name="heard_about_us"
                      disabled={heardAboutUs.loading || heardAboutUs.error}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.heard_about_us}
                      className={`${
                        Boolean(formik.errors.heard_about_us) &&
                        formik.touched.heard_about_us
                          ? "is-invalid"
                          : ""
                      }`}
                    >
                      <option value="">{heardAboutUs.loading ? "Loading options..." : "Select an option"}</option>
                      {heardAboutUs.options.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </Form.Select>
                    {heardAboutUs.error ? (
                      <div className="text-danger small mt-1">
                        Unable to load options.{' '}
                        <button type="button" className="btn btn-link p-0 align-baseline" onClick={loadHeardAboutUs}>
                          Retry
                        </button>
                      </div>
                    ) : null}
                    {Boolean(formik.errors.heard_about_us) &&
                    formik.touched.heard_about_us ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.heard_about_us}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                </div>
                <div className=" col-md-4 col-12">
                  <Form.Group controlId="referred_by">
                    <Form.Label>Referred By</Form.Label>
                    <Form.Control
                      type="text"
                      name="referred_by"
                      style={{ padding: "0.375rem 0.75rem" }}
                      placeholder="JC-XXXX-XXX"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.referred_by}
                    />
                  </Form.Group>
                </div>
                <hr style={{ borderColor: "#282828", marginBottom: 0 }} />
                <div className="col-12 text-end">
                  <button
                    className="btn btn-dark text-primary"
                    type="submit"
                    disabled={submitting || heardAboutUs.loading || heardAboutUs.error}
                  >
                    {submitting ? (
                      <Spinner
                        as="span"
                        variant="primary"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    ) : null}
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
